module.exports = __webpack_public_path__ + "media/images/person_128x128-53817631dd9ac48790b0df55fdfae26f.jpg";